import React, { useEffect, useState } from 'react';
import TabPage from 'components/common/TabPage';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
// import { Spinner, Modal, Button } from 'react-bootstrap';
import { Spinner, Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { formChangedAction } from 'actions';
import { advocateClientCaseDataAction, advocateClientCaseErrorAction, advocateClientCaseListAPI, caseRegistrationAPI, deleteAdvocateClientCaseAPI, resetCaseDeletedAction, updateAdvocateClientCaseAPI } from 'actions/AdvocateClientCase/AdvocateClientCaseAction';
import { toast } from 'react-toastify';
import { clientDetailAPI, clientDetailsAction, clientDetailsErrorAction, clientListAPI } from 'actions/ClientRegistration/ClientRegistrationAction';
import Moment from "moment";
import TabPage1 from 'components/common/TabPage1';
import { getCourtTypeMasterListAPI } from 'actions/CourtTypeMaster/courtTypeMasterAction';
import loader from '../../assets/img/loader.svg'

const tabArray = ['Case List', 'New Case'];

const listColumnArray = [
  { accessor: 'sl', Header: 'S. No' },
  { accessor: 'clientCode', Header: 'Client Code' },
  { accessor: 'clientName', Header: 'Client Name' },
  { accessor: 'stateName', Header: 'State Name' },
  { accessor: 'totalNoOfCase', Header: 'Total No. Of Case' },
];

const listColumnArray1 = [
  { accessor: 'sls', Header: 'S. No' },
  { accessor: 'caseRecordNo', Header: 'CNR' },
  { accessor: 'clientCaseNo', Header: 'Case No' },
  {
    accessor: 'caseTitle',
    Header: 'Case Title',
    Cell: ({ value }) => (
      <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
        {value}
      </div>
    )
  },
  {
    accessor: 'nextHearingDate',
    Header: 'Next Hearing Date',
    Cell: ({ value }) => {
      return value ? Moment(value).format('DD-MM-YYYY') : '';
    },
  },
  { accessor: 'attendantAdvocateName', Header: 'Attendant  Advocate' },
  { accessor: 'caseStatus', Header: 'Case Status' },
  { accessor: 'deleteCase', Header: 'Delete' },
];

export const AdvocateClientCase = () => {
  const dispatch = useDispatch();
  const [advocateClientCaseList, setAdvocateClientCaseList] = useState([]);
  const [clientCaseList, setClientCaseList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [newCaseModel, setNewCaseModel] = useState(false);
  const [courtTypeList, setCourtTypeList] = useState([]);

  const [perPage, setPerPage] = useState(15);
  const [confModalShow, setConfModalShow] = useState(false);
  const [formHasError, setFormError] = useState(false);
  const [showCourtDropdown, setShowCourtDropdown] = useState(false);
  const [clientStatuss, setClientsStatus] = useState("");

  const [activeTabName, setActiveTabName] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [clientList, setClientList] = useState([]);
  const selectedCaseId = localStorage.getItem('EncryptedResponseCaseId')
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [searchText, setSearchText] = useState("");
  var clientStatus = localStorage.getItem('ClientStatus');
  var clientType = localStorage.getItem('ClientType');

  let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
  const headers = {
    Authorization: `Bearer ${JSON.parse(token).value}`
  };

  let oldCaseStatus = localStorage.getItem("OldCaseStatus");

  const getClientList = async (page, size = pageSize) => {
    const data = {
      pageNumber: page,
      pageSize: size,
      SearchText: '',
      EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode'),
      isDropDown: true
    };
    setIsLoading(true);
    await dispatch(
      clientListAPI(
        data,
        res => {
          setIsLoading(false)
          let clientData = [];

          if (res.data.data.clientList.length > 0)
            res.data.data.clientList.forEach(client => {
              clientData.push({
                key: client.clientName,
                value: client.clientCode,
                label: client.clientName
              });
            });
          setClientList(clientData);
          if (res.data.data.clientList && res.data.data.clientList.length === 1) {
            getAdvocateClientCaseList(1, pageSize, "", res.data.data.clientList[0].clientCode)
          }
        },
        err => {
          setClientList([]);
          setIsLoading(false)
          console.log(err?.data.message);
        },
        headers
      )
    );
  };

  const getAdvocateClientCaseList = async (page, size = pageSize, searchText, selectedClientCode) => {
    const data = {
      pageNumber: page,
      PageSize: size,
      searchText: searchText ? searchText : "",
      encryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode'),
      clientCode: selectedClientCode ? selectedClientCode : localStorage.getItem('ClientCode')
    };
    setIsLoading(true);
    await dispatch(
      advocateClientCaseListAPI(
        data,
        response => {
          setIsLoading(false)
          if (data.clientCode) {
            setClientCaseList(response.data.data.advocateCaseList);
            setTotalCount(response.data.data.totalCount);
          }
          else {
            localStorage.removeItem("ClientCode")
            setAdvocateClientCaseList(response.data.data.advocateCaseList);
            setTotalCount(response.data.data.totalCount);
          }
        },
        err => {
          setIsLoading(false)
          setAdvocateClientCaseList([]);
          setClientCaseList([]);
          console.log(err?.data.message);
        },
        headers
      )
    );
  };

  const getClientDetail = async (ClientCode) => {
    var request = {
      ClientCode: ClientCode
    }
    setIsLoading(true);
    await dispatch(
      clientDetailAPI(
        request,
        res => {
          setIsLoading(false)
          var clientDetail = res.data.data.clientDetail
          dispatch(clientDetailsAction({
            ...clientData,
            clientName: clientDetail.client_Name ? clientDetail.client_Name : clientDetail.clientType == "offender" ? clientDetail.offenderName : clientDetail.clientType == "offender" ? clientData.offenderName : clientDetail.client_Name,
            emailId: clientDetail.eMail_Id,
            mobileNo: clientDetail.mobile_No,
            ...clientDetail,
            clientCode: clientDetail.client_Code,
            stateCode: clientDetail.state_Code,
            countryCode: clientDetail.country_Code,
            clientType: "existingClient"

          }));
          if (advocateClientCaseData.caseRecordNo) {
            dispatch(
              advocateClientCaseDataAction({
                ...advocateClientCaseData,
                cRNo: advocateClientCaseData.caseRecordNo || '',
                //  advocateClientCaseData: "Offender"

              })
            );
            $('#textCrno').attr('disabled', true)
          }
        },
        err => {
          setIsLoading(false)
          toast.error(err?.data?.message || 'Error fetching client', {
            theme: 'colored',
            autoClose: 10000
          });
          dispatch(advocateClientCaseDataAction(undefined));
        },
        headers
      )
    );
  };

  useEffect(() => {
    //  localStorage.removeItem("ClientCode")
    localStorage.removeItem("ClientStatus")
    getAdvocateClientCaseList(1, pageSize, searchText);
    // if (!localStorage.getItem("ClientCode")) {
    //   getAdvocateClientCaseList(1, pageSize);
    // }
    getCourtTypeList();
    getClientList(1)
    if (oldCaseStatus === "DISPOSED") {
      // $('#btnSave').attr('disabled', true);
      // $("#btnSave").hide();
    }
    $('[data-rr-ui-event-key*="New Case"]').attr('disabled', true);
    $('[data-rr-ui-event-key*="Case List"]').attr('disabled', false);
  }, []);

  const advocateClientCaseReducer = useSelector(
    state => state.rootReducer.advocateClientCaseReducer
  );
  var advocateClientCaseData = advocateClientCaseReducer.advocateClientCaseData
  const advocateClientCaseDetailsErrorReducer = useSelector(
    state => state.rootReducer.advocateClientCaseDetailsErrorReducer
  );
  const caseDetailError = advocateClientCaseDetailsErrorReducer.advocateClientCaseDetailsError;
  const clientDetailReducer = useSelector(
    state => state.rootReducer.clientRegistrationReducer
  );
  var clientData = clientDetailReducer.clientData;

  const formChangedReducer = useSelector(
    state => state.rootReducer.formChangedReducer
  );
  var formChangedData = formChangedReducer.formChanged;

  let isFormChanged = Object.values(formChangedData).some(
    value => value === true
  );
  const caseDeleted = useSelector(state => state.rootReducer.advocateClientCaseReducer.caseDeleted);

  useEffect(() => {
    if (caseDeleted) {
      getAdvocateClientCaseList(1, pageSize, searchText)
      dispatch(resetCaseDeletedAction(false));
    }
  }, [caseDeleted, dispatch]);

  useEffect(() => {
    if (clientStatus) {
      dispatch(
        clientDetailsAction({
          ...clientData,
          clientType: "existingClient",
        }))
    }
  }, []);

  const clearAdvocateClientCaseReducers = () => {
    dispatch(advocateClientCaseDataAction(undefined))
    dispatch(advocateClientCaseErrorAction(undefined))
    dispatch(formChangedAction(undefined));
  };

  const clearClientReducers = () => {
    dispatch(clientDetailsAction(undefined));
    dispatch(clientDetailsErrorAction(undefined));
    dispatch(formChangedAction(undefined));
  };

  $('[data-rr-ui-event-key*="Case List"]')
    .off('click')
    .on('click', function () {
      let isDiscard = $('#btnDiscard').attr('isDiscard');
      if (isDiscard != 'true' && isFormChanged) {
        setModalShow(true);
        setTimeout(function () {
          $('[data-rr-ui-event-key*="' + activeTabName + '"]').trigger('click');
        }, 50);
      } else {
        $('#btnNew').show();
        $('#btnNewCase').show();
        $('#btnCancel').hide();
        $('#btnSave').hide();
        $('[data-rr-ui-event-key*="New Case"]').attr('disabled', true);
        $('[data-rr-ui-event-key*="Case List"]').attr('disabled', false);
        $('#addAdvocateClientCaseDetailsForm').get(0).reset();
        localStorage.removeItem("EncryptedResponseCaseId");
        localStorage.removeItem("OldCaseStatus")
        localStorage.removeItem("OldCaseStatus")
        localStorage.removeItem("CourtMasterType")
        localStorage.removeItem("CourtMasterTypeCode");
        localStorage.removeItem("ClientStatus");
        $('#btnDiscard').attr('isDiscard', false);
        clearAdvocateClientCaseReducers();
        clearClientReducers();
      }
    });

  $('[data-rr-ui-event-key*="New Case"]')
    .off('click')
    .on('click', function () {
      setActiveTabName('New Case');
      $('#btnNew').hide();
      $('#btnNewCase').hide();
      $('#btnCancel').show();
       $('#btnSave').show();
      // if (oldCaseStatus === "DISPOSED") {
      //   $('#btnSave').hide();
      // } else {
      //   $('#btnSave').show();
      // }
    });

  const newDetails = () => {
    $('[data-rr-ui-event-key*="New Case"]').attr('disabled', false);
    $('[data-rr-ui-event-key="New Case"]').trigger('click');
    $('#btnSave').attr('disabled', false);
    clearAdvocateClientCaseReducers();
    clearClientReducers();

    if (clientStatus == "NewClient") {
      localStorage.removeItem('ClientCode')
      localStorage.removeItem('EncryptedResponseClientCode')
      localStorage.removeItem("EncryptedResponseCaseId")
    }
  };

  const newCase = () => {
    localStorage.removeItem("CourtMasterType")
    localStorage.removeItem("CourtMasterTypeCode");
    setNewCaseModel(true);
  };
  const cancelClick = () => {
    $('#btnExit').attr('isExit', 'false');
    if (isFormChanged) {
      setModalShow(true);
    } else {
      $('[data-rr-ui-event-key*="Case List"]').trigger('click');
    }
  };

  const exitModule = () => {
    $('#btnExit').attr('isExit', 'true');
    if (isFormChanged) {
      setModalShow(true);
    } else {
      window.location.href = '/dashboard';
      dispatch(advocateClientCaseDataAction(undefined))
      localStorage.removeItem("EncryptedResponseCaseId")
      localStorage.removeItem("OldCaseStatus");
      localStorage.removeItem("CourtMasterType")
      localStorage.removeItem("CourtMasterTypeCode");
      localStorage.removeItem("ClientStatus");
    }
  };

  const discardChanges = () => {
    $('#btnDiscard').attr('isDiscard', 'true');
    if ($('#btnExit').attr('isExit') == 'true')
      window.location.href = '/dashboard';
    else $('[data-rr-ui-event-key*="List"]').trigger('click');
    setNewCaseModel(false)
    setModalShow(false);
  };

  const advocateClientCaseValidation = (value) => {
    const clientNameErr = {};
    const caseNoErr = {};
    const countryErr = {};
    const stateErr = {};
    const courtNameErr = {};
    const caseTypeErr = {};
    const registerDateErr = {};
    const nextHearingDateErr = {};
    const addvocateMobileNoErr = {};
    const caseTitleErr = {};
    const clientErr = {};
    const purposeErr = {};
    const cnrErr = {};

    let isValid = true;
    // if ( !advocateClientCaseData.clientCode) {
    //   clientNameErr.empty = 'Select client';
    //   isValid = false;
    //   setFormError(true);
    // }

    if (clientData.clientType == "existingClient") {
      if (!clientData.clientCode) {
        toast.error("Select Client", {
          theme: 'colored',
          autoClose: 10000
        });

        setFormError(true);
      }
    }
    // else if(!value){
    //     if (!advocateClientCaseData.clientCode) {

    //     clientNameErr.empty = 'Select client';
    //     isValid = false;
    //     setFormError(true);
    //   }
    // }
    if (advocateClientCaseData.cRNo != null && advocateClientCaseData.cRNo != "") {
      if (advocateClientCaseData.cRNo && advocateClientCaseData.cRNo.length !== 16) {
        cnrErr.empty = 'Case number record should have 16 long';
        isValid = false;
        setFormError(true);
      } else if (!/^[A-Z]{4}\d{12}$/i.test(advocateClientCaseData.cRNo)) {
        cnrErr.invalidFormat = 'CNR must start with 4 letters followed by 12 digits';
        isValid = false;
        setFormError(true);
      }
    }

    if (!advocateClientCaseData.countryCode) {
      countryErr.empty = 'Select country';
      isValid = false;
      setFormError(true);
    }
    if (!advocateClientCaseData.caseCode) {
      caseTypeErr.empty = 'Select case type';
      isValid = false;
      setFormError(true);
    }

    if (!advocateClientCaseData.stateCode) {
      stateErr.empty = 'Select state';
      isValid = false;
      setFormError(true);
    }

    if (!advocateClientCaseData.clientCaseNo) {
      caseNoErr.caseNoEmpty = 'Please enter case no';
      isValid = false;
      setFormError(true);
    }

    if (!advocateClientCaseData.courtCode) {
      courtNameErr.caseNoEmpty = 'Select court name';
      isValid = false;
      setFormError(true);
    }
    if (!advocateClientCaseData.caseRegisterDate) {
      registerDateErr.regDateEmpty = 'Select register date';
      isValid = false;
      setFormError(true);
    }
    if (!advocateClientCaseData.nextHearingDate) {
      nextHearingDateErr.nxtHearingDateEmpty = 'Select next hearing date';
      isValid = false;
      setFormError(true);
    }
    else if (advocateClientCaseData.nextHearingDate <= advocateClientCaseData.caseRegisterDate) {
      nextHearingDateErr.endDateInvalid = "Next hearing date cannot be same or less than register Date";
      isValid = false;
      setFormError(true);
    }

    if (advocateClientCaseData.oppAdvMob) {
      if (!/^(?!0)[0-9]{10}$/.test(advocateClientCaseData.oppAdvMob)) {
        addvocateMobileNoErr.phoneInvalid =
          'Invalid mobile number, number should be of 10 digits should not start with 0';
        isValid = false;
        setFormError(true);
      }
    }
    if (!advocateClientCaseData.caseTitle) {
      caseTitleErr.caseNoEmpty = 'Please enter case title';
      isValid = false;
      setFormError(true);
    }
    if (!advocateClientCaseData.purpose) {
      purposeErr.Empty = 'Select purpose';
      isValid = false;
      setFormError(true);
    }
    if (!advocateClientCaseData.party) {
      clientErr.Empty = 'Select client';
      isValid = false;
      setFormError(true);
    }

    // if (isValid) {
    //   setIsSubmitting(true);
    // }
    if (!isValid) {
      var errorObject = {
        clientNameErr,
        caseNoErr,
        countryErr,
        stateErr,
        caseTypeErr,
        courtNameErr,
        registerDateErr,
        nextHearingDateErr,
        addvocateMobileNoErr,
        caseTitleErr,
        purposeErr,
        clientErr,
        cnrErr
      };
      dispatch(advocateClientCaseErrorAction(errorObject));
    }

    return isValid;
  };
  const clientValidation = () => {
    const emailOffenderErr = {};
    const countryOffenderErr = {};
    const stateOffenderErr = {};
    const mobileNoOffenderErr = {};
    const offenderNameErr = {};

    const emailDefenderErr = {};
    const countryDefenderErr = {};
    const stateDefenderErr = {};
    const mobileNoDefenderErr = {};
    const defenderNameErr = {};

    let isValid = true;

    if (clientData.clientType === "offender") {
      if (!clientData.offenderName) {
        offenderNameErr.empty = "Enter offender name";
        isValid = false;
        setFormError(true);
      }

      if (!clientData.countryCodeOffender) {
        countryOffenderErr.empty = "Select country";
        isValid = false;
        setFormError(true);
      }

      if (!clientData.stateCodeOffender) {
        stateOffenderErr.empty = "Select state";
        isValid = false;
        setFormError(true);
      }

      if (!clientData.mobileNoOffender) {
        mobileNoOffenderErr.mobileNoErr = "Enter mobile no";
        isValid = false;
        setFormError(true);
      } else if (!/^(?!0)[0-9]{10}$/.test(clientData.mobileNoOffender)) {
        mobileNoOffenderErr.phoneInvalid =
          "Invalid mobile number, number should be of 10 digits and should not start with 0";
        isValid = false;
        setFormError(true);
      }

      if (!clientData.emailIdOffender) {
        emailOffenderErr.empty = "Enter email address";
        isValid = false;
        setFormError(true);
      } else if (
        !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(clientData.emailIdOffender)
      ) {
        emailOffenderErr.invalid = "Please enter valid email address";
        isValid = false;
        setFormError(true);
      }
    }

    if (clientData.clientType === "defender") {
      if (!clientData.defenderName) {
        defenderNameErr.empty = "Enter defender name";
        isValid = false;
        setFormError(true);
      }

      if (!clientData.countryCodeDefender) {
        countryDefenderErr.empty = "Select country";
        isValid = false;
        setFormError(true);
      }

      if (!clientData.stateCodeDefender) {
        stateDefenderErr.empty = "Select state";
        isValid = false;
        setFormError(true);
      }

      if (!clientData.mobileNoDefender) {
        mobileNoDefenderErr.mobileNoErr = "Enter mobile no";
        isValid = false;
        setFormError(true);
      } else if (!/^(?!0)[0-9]{10}$/.test(clientData.mobileNoDefender)) {
        mobileNoDefenderErr.phoneInvalid =
          "Invalid mobile number, number should be of 10 digits and should not start with 0";
        isValid = false;
        setFormError(true);
      }

      if (!clientData.emailIdDefender) {
        emailDefenderErr.empty = "Enter email address";
        isValid = false;
        setFormError(true);
      } else if (
        !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(clientData.emailIdDefender)
      ) {
        emailDefenderErr.invalid = "Please enter valid email address";
        isValid = false;
        setFormError(true);
      }
    }

    if (!isValid) {
      const errorObject = {
        offenderNameErr,
        emailOffenderErr,
        countryOffenderErr,
        stateOffenderErr,
        mobileNoOffenderErr,
        defenderNameErr,
        emailDefenderErr,
        countryDefenderErr,
        stateDefenderErr,
        mobileNoDefenderErr,
      };

      dispatch(clientDetailsErrorAction(errorObject));
    }

    return isValid;
  };

  // const courtTypeValidation = () => {
  //   const courtTypeErr = {};
  //   let isValid = true;

  //   if (!advocateClientCaseData.courtTypeCode) {
  //     toast.error('Select court type', {
  //       theme: 'colored',
  //       autoClose: 10000
  //     });
  //     isValid = false;
  //   }

  //   if (isValid) {
  //     setIsSubmitting(true);
  //   }

  //   if (!isValid) {
  //     var errorObject = {
  //       courtTypeErr
  //     };
  //     dispatch(advocateClientCaseErrorAction(errorObject));
  //   }
  //   return isValid;
  // };

  const addAdvocateClientDetails = async () => {
    let isClientValid = true;
    if (clientData.clientType != "existingClient") {
      isClientValid = clientValidation();
      if (isClientValid) {
        dispatch(clientDetailsErrorAction(undefined));
      }
    }

    const isCaseValid = advocateClientCaseValidation();
    if (
      (clientData.clientType !== "existingClient" && isClientValid && isCaseValid) ||
      (clientData.clientType === "existingClient" && isCaseValid || isCaseValid)
    ) {
      // if (i
      // sSubmitting) return
      const data = {
        EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode'),
        ClientCode: clientData.clientCode || advocateClientCaseData.clientCode || localStorage.getItem('ClientCode'),
        AttendantAdvocateName: advocateClientCaseData.attendantAdvocateName ? advocateClientCaseData.attendantAdvocateName : "",
        CaseStatus: advocateClientCaseData.caseStatus,
        CaseRecordNo: advocateClientCaseData.cRNo ? advocateClientCaseData.cRNo : "",
        ClientCaseNo: advocateClientCaseData.clientCaseNo,
        // ClientCode: advocateClientCaseData.clientCode,
        CourtCode: advocateClientCaseData.courtCode ? advocateClientCaseData.courtCode : "",
        RoomNo: advocateClientCaseData.roomNo ? advocateClientCaseData.roomNo : "",
        Almirah: advocateClientCaseData.almirah ? advocateClientCaseData.almirah : "",
        StateCode: advocateClientCaseData.stateCode,
        FileDescription: advocateClientCaseData.fileDescription ? advocateClientCaseData.fileDescription : "",
        Rack: advocateClientCaseData.rack ? advocateClientCaseData.rack : "",
        JudgeName: advocateClientCaseData.judgeName ? advocateClientCaseData.judgeName : "",
        CaseTypeCode: advocateClientCaseData.caseCode,
        CourtNo: advocateClientCaseData.courtNo ? advocateClientCaseData.courtNo : "",
        CaseRegisterDate: advocateClientCaseData.caseRegisterDate,
        NextHearingDate: advocateClientCaseData.nextHearingDate,
        ConsultingFees: advocateClientCaseData.consultingFees ? advocateClientCaseData.consultingFees : "0.00",
        FileNo: advocateClientCaseData.fileNo ? advocateClientCaseData.fileNo : "",
        PoliceStation: advocateClientCaseData.policeStation ? advocateClientCaseData.policeStation : "",
        FIRDate: advocateClientCaseData.firDate ? advocateClientCaseData.firDate : null,
        CaseNature: advocateClientCaseData.caseNature ? advocateClientCaseData.caseNature : "",
        CaseTitle: advocateClientCaseData.caseTitle,
        Purpose: advocateClientCaseData.purpose ? advocateClientCaseData.purpose : "",
        OppAdvName: advocateClientCaseData.oppAdvName ? advocateClientCaseData.oppAdvName : "",
        OppAdvMob: advocateClientCaseData.oppAdvMob ? advocateClientCaseData.oppAdvMob : "",
        UnderSection: advocateClientCaseData.underSection ? advocateClientCaseData.underSection : "",
        FIRNo: advocateClientCaseData.firNo ? advocateClientCaseData.firNo : "",
        Party: advocateClientCaseData.party ? advocateClientCaseData.party : "",
        EmailId: advocateClientCaseData.emailId ? advocateClientCaseData.emailId : clientData.clientType == "existingClient" && clientData.emailId ? clientData.emailId : clientData.emailIdDefender && clientData.clientType == "defender" ? clientData.emailIdDefender : clientData.emailIdOffender && clientData.clientType == "offender" ? clientData.emailIdOffender : "",
        FilingNo: advocateClientCaseData.filingNo ? advocateClientCaseData.filingNo : "",
        FilingDate: advocateClientCaseData.filingDate ? advocateClientCaseData.filingDate : null,
        AddUser: localStorage.getItem('LoginUserName'),
        // CaseFilingYear: advocateClientCaseData.caseFilingYear ? advocateClientCaseData.caseFilingYear : "",
        // DiaryNumber: advocateClientCaseData.diaryNumber ? advocateClientCaseData.diaryNumber : "",
        IsClientExist: clientData.clientType != "existingClient" || clientStatus == "NewClient" ? false : clientData.clientType == "existingClient" ? true : true,
        clientRegister: {
          EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode'),
          ClientName: clientData.defenderName && clientData.clientType == "defender" ? clientData.defenderName : clientData.clientType == "offender" && clientData.offenderName ? clientData.offenderName : "",
          CountryCode: clientData.countryCodeDefender && clientData.clientType == "defender" ? clientData.countryCodeDefender : clientData.countryCodeOffender && clientData.clientType == "offender" ? clientData.countryCodeOffender : "",
          StateCode: clientData.stateCodeDefender && clientData.clientType == "defender" ? clientData.stateCodeDefender : clientData.stateCodeOffender && clientData.clientType == "offender" ? clientData.stateCodeOffender : "",
          EmailId: clientData.emailIdDefender && clientData.clientType == "defender" ? clientData.emailIdDefender : clientData.emailIdOffender && clientData.clientType == "offender" ? clientData.emailIdOffender : "",
          MobileNo: clientData.mobileNoDefender && clientData.clientType == "defender" ? clientData.mobileNoDefender : clientData.mobileNoOffender && clientData.clientType == "offender" ? clientData.mobileNoOffender : "",
          AddUser: localStorage.getItem('LoginUserName'),
        }

      }
      const keys = [
        'AttendantAdvocateName',
        'CaseStatus',
        'FileDescription',
        'JudgeName',
        'PoliceStation',
        'CaseNature',
        'CaseTitle',
        'OppAdvName',
        'EmailId',
        'FileNo',
        'Rack',
        'FIRNo',
        'UnderSection',
        'CourtNo',
        'Almirah',
        // 'DiaryNumber',
        'AddUser'
      ];
      for (const key of Object.keys(data).filter(key => keys.includes(key))) {
        data[key] = data[key] ? data[key].toUpperCase() : '';
      }
      const clientRegisterKeys = [
        'ClientName',
        'EmailId',
        'AddUser'
      ];

      for (const key of Object.keys(data.clientRegister).filter(key => clientRegisterKeys.includes(key))) {
        data.clientRegister[key] = data.clientRegister[key]
          ? data.clientRegister[key].toUpperCase()
          : '';
      }
      setIsLoading(true);
      await dispatch(
        caseRegistrationAPI(
          data,
          response => {
            setIsLoading(false);
            toast.success(` ${response.data.message}`, {
              theme: 'colored',
              autoClose: 10000
            });
            updateCallback(true)
            setModalShow(false);
            localStorage.setItem(
              'EncryptedResponseCaseId',
              response.data.data.encryptedAdvocateClientCaseId
            );
            // setNewCaseModel(false)
            $('#btnSave').attr('disabled', true)
            setActiveTabName('New Case');
            $('[data-rr-ui-event-key*="New Case"]').attr('disabled', false);
            $('[data-rr-ui-event-key="New Case"]').trigger('click');
            $('#btnSave').attr('disabled', false);
            const clientCode = response.data.data.clientCode;
            if (clientCode) {
              localStorage.setItem('ClientCode', clientCode);
              getClientDetail(clientCode);

            }
            localStorage.setItem("OldCaseStatus", advocateClientCaseData.caseStatus);
          },
          err => {
            setIsLoading(false)
            toast.error(err?.data.message, {
              theme: 'colored',
              autoClose: 10000
            });
          },
          headers
        )
      );
    }
  };

  const updateCallback = async (isAddAdvocateCaseClient = false) => {
    setModalShow(false);
    setIsSubmitting(false)
    dispatch(formChangedAction(undefined));
    dispatch(advocateClientCaseErrorAction(undefined));
    if (advocateClientCaseData.cRNo != null && advocateClientCaseData.cRNo != "") {
      dispatch(advocateClientCaseDataAction({
        ...advocateClientCaseData,
        caseRecordNo: advocateClientCaseData.cRNo
      }))
    }
    if (!isAddAdvocateCaseClient) {
      toast.success("Advocate client case details updated successfully!", {
        theme: 'colored'
      });
    }

    $('#btnSave').attr('disabled', true)
    if (!localStorage.getItem('ClientCode')) {
      getAdvocateClientCaseList(1, pageSize, searchText);
    } else {
      getAdvocateClientCaseList(1, pageSize, searchText, localStorage.getItem('ClientCode'))
    }

    $('[data-rr-ui-event-key*="' + activeTabName + '"]').trigger('click');
  }

  const updateAdvocateClientCaseDetails = async () => {

    if (advocateClientCaseValidation()) {
      if (isSubmitting) return
      const data = {
        EncryptedCaseId: advocateClientCaseData.encryptedCaseId ? advocateClientCaseData.encryptedCaseId : selectedCaseId,
        AttendantAdvocateName: advocateClientCaseData.attendantAdvocateName ? advocateClientCaseData.attendantAdvocateName : "",
        CaseStatus: advocateClientCaseData.caseStatus,
        ClientCaseNo: advocateClientCaseData.clientCaseNo,
        CourtCode: advocateClientCaseData.courtCode ? advocateClientCaseData.courtCode : "",
        RoomNo: advocateClientCaseData.roomNo ? advocateClientCaseData.roomNo : "",
        Almirah: advocateClientCaseData.almirah ? advocateClientCaseData.almirah : "",
        StateCode: advocateClientCaseData.stateCode,
        FileDescription: advocateClientCaseData.fileDescription ? advocateClientCaseData.fileDescription : "",
        Rack: advocateClientCaseData.rack ? advocateClientCaseData.rack : "",
        JudgeName: advocateClientCaseData.judgeName ? advocateClientCaseData.judgeName : "",
        CaseTypeCode: advocateClientCaseData.caseCode,
        CourtNo: advocateClientCaseData.courtNo ? advocateClientCaseData.courtNo : "",
        CaseRegisterDate: advocateClientCaseData.caseRegisterDate,
        NextHearingDate: advocateClientCaseData.nextHearingDate,
        ConsultingFees: advocateClientCaseData.consultingFees ? advocateClientCaseData.consultingFees : "0.00",
        FileNo: advocateClientCaseData.fileNo ? advocateClientCaseData.fileNo : "",
        PoliceStation: advocateClientCaseData.policeStation ? advocateClientCaseData.policeStation : "",
        FIRDate: advocateClientCaseData.firDate ? advocateClientCaseData.firDate : null,
        CaseNature: advocateClientCaseData.caseNature ? advocateClientCaseData.caseNature : "",
        CaseTitle: advocateClientCaseData.caseTitle,
        Purpose: advocateClientCaseData.purpose ? advocateClientCaseData.purpose : "",
        OppAdvName: advocateClientCaseData.oppAdvName ? advocateClientCaseData.oppAdvName : "",
        OppAdvMob: advocateClientCaseData.oppAdvMob ? advocateClientCaseData.oppAdvMob : "",
        UnderSection: advocateClientCaseData.underSection ? advocateClientCaseData.underSection : "",
        FIRNo: advocateClientCaseData.firNo ? advocateClientCaseData.firNo : "",
        Party: advocateClientCaseData.party ? advocateClientCaseData.party : "",
        CaseRecordNo: advocateClientCaseData.cRNo ? advocateClientCaseData.cRNo : advocateClientCaseData.caseRecordNo ? advocateClientCaseData.caseRecordNo : "",
        CaseFilingYear: advocateClientCaseData.caseFilingYear ? advocateClientCaseData.caseFilingYear : "",
        FilingNo: advocateClientCaseData.filingNo ? advocateClientCaseData.filingNo : "",
        FilingDate: advocateClientCaseData.filingDate ? advocateClientCaseData.filingDate : null,
        DiaryNumber: advocateClientCaseData.diaryNumber ? advocateClientCaseData.diaryNumber : "",
        ModifyUser: localStorage.getItem('LoginUserName')
      }
      const keys = [
        'AttendantAdvocateName',
        'CaseStatus',
        'FileDescription',
        'JudgeName',
        'PoliceStation',
        'CaseNature',
        'CaseTitle',
        'OppAdvName',
        'EmailId',
        'FileNo',
        'Rack',
        'CourtNo',
        'Almirah',
        'FIRNo',
        'RoomNo',
        'UnderSection',
        'CaseRecordNo',
        'DiaryNumber',
        'FilingNo',
        'ModifyUser'
      ];
      for (const key of Object.keys(data).filter(key => keys.includes(key))) {
        data[key] = data[key] ? data[key].toUpperCase() : '';
      }
      setIsLoading(true);
      if (formChangedData.AdvocateClientCaseUpdate) {
        await dispatch(
          updateAdvocateClientCaseAPI(
            data,
            response => {
              setIsLoading(false);
              toast.success(` ${response.data.message}`, {
                theme: 'colored',
                autoClose: 10000
              });
              if (advocateClientCaseData.cRNo != null && advocateClientCaseData.cRNo != "") {
                dispatch(advocateClientCaseDataAction({
                  ...advocateClientCaseData,
                  caseRecordNo: advocateClientCaseData.cRNo
                }))
              }
              updateCallback(true)
              setModalShow(false);
              localStorage.setItem("OldCaseStatus", advocateClientCaseData.caseStatus);
            },
            err => {
              setIsLoading(false)
              toast.error(err?.data.message, {
                theme: 'colored',
                autoClose: 10000
              });
            },
            headers
          )
        );
      }
    }
  };

  const getCourtTypeList = (page, size = perPage) => {
    const data = {
      isDropdown: true
    };
    dispatch(
      getCourtTypeMasterListAPI(
        data,
        res => {
          let courtTypeData = [];
          if (res.data.data.courtTypeMasterList.length > 0)
            res.data.data.courtTypeMasterList.forEach(courtType => {
              courtTypeData.push({
                key: courtType.courtTypeName,
                value: courtType.courtTypeCode
              });
            });
          setCourtTypeList(courtTypeData);
        },
        err => {
          toast.error(err?.data?.message || 'Error fetching court types list', {
            theme: 'colored',
            autoClose: 10000
          });
          setCourtTypeList([]);
        },
        headers
      )
    );
  };

  const handleFieldChange = e => {
    // if (e.target.name == 'courtType') {
    //   const selectedCourt = e.target.options[e.target.selectedIndex].text;
    //   localStorage.setItem("CourtMasterTypeCode", selectedCourt);
    //   localStorage.setItem("CourtMasterType", e.target.value);
    //   dispatch(advocateClientCaseDataAction({
    //     ...advocateClientCaseData,
    //     courtTypeCode: e.target.value
    //   }))
    // }
    if (e.target.value) {
      localStorage.setItem("ClientStatus", "ExitingClient");
      dispatch(
        clientDetailsAction({
          ...clientData,
          clientType: "existingClient"
        })
      );
      localStorage.setItem("ClientCode", e.target.value);
      getAdvocateClientCaseList(1, pageSize, searchText, e.target.value);
    } else {
      localStorage.setItem("ClientStatus", "NewClient");
      localStorage.removeItem("ClientCode")
      getAdvocateClientCaseList(1, pageSize, searchText, "");
    }
    // else {
    //   localStorage.removeItem("ClientCode")
    //   console.log("ehllo")
    //   getAdvocateClientCaseList(1, pageSize, searchText)
    // }
  }

  // const handleClientChoice = (isExisting) => {
  //   if (isExisting == "ExitingClient") {
  //     setClientsStatus("ExitingClient");
  //     localStorage.setItem('ClientStatus', isExisting)
  //     setShowCourtDropdown(true);
  //   } else if (isExisting == "NewClient") {
  //     setClientsStatus("NewClient");
  //     localStorage.setItem('ClientStatus', isExisting)
  //     setShowCourtDropdown(true);
  //   } else if (isExisting == "Proceed") {
  //     if (courtTypeValidation()) {
  //       setConfModalShow(false);
  //       newDetails()
  //       setShowCourtDropdown(false);
  //     } else {
  //       setShowCourtDropdown(true);
  //     }
  //   }
  // };

  // const handleClick = () => {

  //   setConfModalShow(true);
  // };

  // const handleRedirectClick = async (value) => {

  //    await addAdvocateClientDetails();
  // };
  return (
    <>
      {isLoading ? (
        <img
          src={loader}
          alt="Loading..."
          className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
        />
      ) : null}
      {/* {isLoading ? (
        <Spinner
           className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          animation="border"
        />
      ) : null} */}
      {modalShow && (
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Confirmation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Do you want to save changes?</h4>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              onClick={
                advocateClientCaseData.encryptedCaseId || selectedCaseId ? updateAdvocateClientCaseDetails :
                  addAdvocateClientDetails
              }
            >
              Save
            </Button>
            <Button
              variant="danger"
              id="btnDiscard"
              onClick={() => discardChanges()}
            >
              Discard
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* {confModalShow && (
        <Modal
          show={confModalShow}
          onHide={() => {
            setConfModalShow(false);
            setShowCourtDropdown(false);
          }}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Confirmation
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {!showCourtDropdown ? (
              <h4>Is this new case for your existing client?</h4>
            ) : (
              <>
                <Form.Label>
                  Court Type <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  id="txtCourtType"
                  name="courtType"
                  value={advocateClientCaseData.courtType}
                  onChange={handleFieldChange}
                >
                  <option value="">Select</option>
                  {courtTypeList.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.key}
                    </option>
                  ))}
                </Form.Select>
              </>
            )}
          </Modal.Body>

          <Modal.Footer>
            {!showCourtDropdown ? (
              <>
                <Button
                  variant="success"
                  onClick={() => handleClientChoice("ExitingClient")}
                >
                  Yes
                </Button>
                <Button
                  variant="danger"
                  id="btnDiscard"
                  onClick={() => handleClientChoice("NewClient")}
                >
                  No
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="primary"
                  onClick={() => handleClientChoice("Proceed")}
                >
                  Proceed
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => {
                    setConfModalShow(false);
                    setShowCourtDropdown(false);
                  }}
                >
                  Cancel
                </Button>
              </>
            )}
          </Modal.Footer>
        </Modal>
      )} */}

      {/* {newCaseModel && (
        <Modal
          show={newCaseModel}
          onHide={() => setNewCaseModel(false)}
          size="xl"
          dialogClassName="modal-fullscreen-custom"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static">
          <Modal.Body className='pb-0'>
            <AdvocateClientCaseDetail1 layout="popup" />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              onClick={
              ()=>  handleRedirectClick("isPopUp")
              }
            >
              Add case
            </Button>
            <Button
              variant="danger"
              id="btnDiscard"
              onClick={() => discardChanges()}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      )} */}

      <TabPage1
        listData={localStorage.getItem("ClientCode") ? clientCaseList : advocateClientCaseList}
        listColumnArray={localStorage.getItem("ClientCode") ? listColumnArray1 : listColumnArray}
        tabArray={tabArray}
        module="CaseRegistration"
        saveDetails={
          advocateClientCaseData.encryptedCaseId || selectedCaseId ? updateAdvocateClientCaseDetails :
            addAdvocateClientDetails
        }
        // newDetails={handleClick}
        newDetails={newDetails}
        // caseDetails={newCase}
        cancelClick={cancelClick}
        exitModule={exitModule}
        tableFilterOptions={clientList}
        tableFilterName={'Client'}
        supportingMethod1={handleFieldChange}
        pageSize={pageSize}
        setPageSize={(value) => setPageSize(value)}
        searchText={searchText}
        setSearchTextValue={(value) => setSearchText(value)}
        fetchList={getAdvocateClientCaseList}
        listCount={totalCount}
      />
    </>
  );
};

export default AdvocateClientCase;